var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import filters from 'common/filters.js';
import { sanitizeTextForMol } from 'packages/mol/MolTextSanitizer';
import isNil from 'common/support/isNil';
import { MolEmploymentRelationship } from 'packages/mol/entities/MolEmploymentRelationship';
var MolPublishStatus;
(function (MolPublishStatus) {
    MolPublishStatus["Draft"] = "draft";
    MolPublishStatus["Sent"] = "sent";
    MolPublishStatus["Failed"] = "publish-failed";
})(MolPublishStatus || (MolPublishStatus = {}));
var MolRequirements = /** @class */ (function (_super) {
    __extends(MolRequirements, _super);
    function MolRequirements() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ESCO occupation code
        _this.occupations = null;
        return _this;
    }
    return MolRequirements;
}(Entity));
export { MolRequirements };
var MolSalary = /** @class */ (function (_super) {
    __extends(MolSalary, _super);
    function MolSalary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.typeCode = null;
        _this.additionalInfo = null;
        return _this;
    }
    return MolSalary;
}(Entity));
export { MolSalary };
var MolPartTimeEmployment = /** @class */ (function (_super) {
    __extends(MolPartTimeEmployment, _super);
    function MolPartTimeEmployment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.workingHoursPeriod = 'week';
        _this.workingHoursMin = null;
        _this.workingHoursMax = null;
        return _this;
    }
    return MolPartTimeEmployment;
}(Entity));
export { MolPartTimeEmployment };
var MolWorkingTime = /** @class */ (function (_super) {
    __extends(MolWorkingTime, _super);
    function MolWorkingTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.workingHourCodes = [];
        _this.workingShiftCodes = [];
        return _this;
    }
    return MolWorkingTime;
}(Entity));
export { MolWorkingTime };
var MolWorkStart = /** @class */ (function (_super) {
    __extends(MolWorkStart, _super);
    function MolWorkStart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.code = null;
        _this.date = null;
        _this.additionalInfo = null;
        return _this;
    }
    return MolWorkStart;
}(Entity));
export { MolWorkStart };
var MolRecruiterContactInfo = /** @class */ (function (_super) {
    __extends(MolRecruiterContactInfo, _super);
    function MolRecruiterContactInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.email = null;
        _this.phone = null;
        _this.firstName = null;
        _this.lastName = null;
        return _this;
    }
    return MolRecruiterContactInfo;
}(Entity));
export { MolRecruiterContactInfo };
var MolJob = /** @class */ (function (_super) {
    __extends(MolJob, _super);
    function MolJob() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.deadlineDate = null;
        _this.name = null;
        _this.description = '';
        _this.companyName = null;
        _this.employerBusinessId = null;
        _this.requirements = new MolRequirements();
        _this.numberOfOpenPositions = null;
        _this.salary = new MolSalary();
        _this.applicationLink = null;
        _this.postalCode = '00100';
        _this.address = null;
        _this.employmentRelationship = new MolEmploymentRelationship();
        _this.employmentContractTypeCode = null;
        _this.contractLengthCode = null;
        _this.partTimeEmployment = new MolPartTimeEmployment();
        _this.workingTime = new MolWorkingTime();
        _this.workStart = new MolWorkStart();
        _this.publishToEures = null;
        _this.recruiterContactInfo = new MolRecruiterContactInfo();
        _this.status = null;
        return _this;
    }
    Object.defineProperty(MolJob.prototype, "isEmploymentRelated", {
        get: function () {
            var _a;
            return ((_a = this.employmentRelationship) === null || _a === void 0 ? void 0 : _a.type) === 'employment';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MolJob.prototype, "isTemporaryAgencyWork", {
        get: function () {
            var _a, _b;
            return ((_a = this.employmentRelationship) === null || _a === void 0 ? void 0 : _a.type) === 'employment' && ((_b = this.employmentRelationship.details) === null || _b === void 0 ? void 0 : _b.isTemporaryAgencyWork);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MolJob.prototype, "isEntrepreneurshipRelated", {
        get: function () {
            var _a;
            return ((_a = this.employmentRelationship) === null || _a === void 0 ? void 0 : _a.type) === 'entrepreneurship';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MolJob.prototype, "isPublishFailed", {
        get: function () {
            return this.status === MolPublishStatus.Failed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MolJob.prototype, "isEmploymentStartDateRequired", {
        get: function () {
            return this.workStart.code === '02';
        },
        enumerable: false,
        configurable: true
    });
    MolJob.prototype.setFailedToPublish = function () {
        this.status = MolPublishStatus.Failed;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MolJob.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        this.recruiterContactInfo = EntityBuilder.buildOne(MolRecruiterContactInfo, jsonData.recruiter_contact_info);
        if (!isNil(this.description)) {
            this.description = sanitizeTextForMol(filters.stripMarkup(this.description.replace(/\<\/\s*p\>/img, '\n')));
        }
        if (!this.partTimeEmployment) {
            this.partTimeEmployment = new MolPartTimeEmployment();
        }
        return this;
    };
    var _a;
    __decorate([
        Type(MolRequirements),
        __metadata("design:type", MolRequirements)
    ], MolJob.prototype, "requirements", void 0);
    __decorate([
        Type(MolSalary),
        __metadata("design:type", MolSalary)
    ], MolJob.prototype, "salary", void 0);
    __decorate([
        Type(MolEmploymentRelationship),
        __metadata("design:type", typeof (_a = typeof MolEmploymentRelationship !== "undefined" && MolEmploymentRelationship) === "function" ? _a : Object)
    ], MolJob.prototype, "employmentRelationship", void 0);
    __decorate([
        Type(MolPartTimeEmployment),
        __metadata("design:type", MolPartTimeEmployment)
    ], MolJob.prototype, "partTimeEmployment", void 0);
    __decorate([
        Type(MolWorkingTime),
        __metadata("design:type", MolWorkingTime)
    ], MolJob.prototype, "workingTime", void 0);
    __decorate([
        Type(MolWorkStart),
        __metadata("design:type", MolWorkStart)
    ], MolJob.prototype, "workStart", void 0);
    __decorate([
        Type(MolRecruiterContactInfo),
        __metadata("design:type", MolRecruiterContactInfo)
    ], MolJob.prototype, "recruiterContactInfo", void 0);
    return MolJob;
}(Entity));
export { MolJob };
